import service from '@/utils/axios';

export const COURSEWARE_AUDIO_API = '/dwart/an_teaching/AiClassRoom/coursewareIndex';

export interface CoursewareAudioParams {
  topicId: string;
}

export interface CoursewareAudioItem {
  index: number;
  url: string;
}

function toStringParam(value: unknown): string | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  return String(value);
}

function parseAudioList(raw: unknown): unknown[] {
  if (Array.isArray(raw)) {
    return raw;
  }
  if (raw && typeof raw === 'object') {
    const obj = raw as Record<string, unknown>;
    const nested = obj.list ?? obj.data ?? obj.contentDTOList ?? obj.items;
    if (Array.isArray(nested)) {
      return nested;
    }
  }
  return [];
}

export function normalizeCoursewareAudioResponse(res: unknown): CoursewareAudioItem[] {
  return parseAudioList(res)
    .map((item) => {
      const row = item as Record<string, unknown>;
      return {
        index: Number(row.index),
        url: toStringParam(row.url) || '',
      };
    })
    .filter((item) => Number.isFinite(item.index));
}

export function getCoursewareAudioUrl(
  list: CoursewareAudioItem[],
  pageIndex: number,
): string {
  const targetIndex = pageIndex + 1;
  const matched = list.find((item) => item.index === targetIndex);
  return matched?.url?.trim() || '';
}

export async function requestCoursewareAudio(
  params: CoursewareAudioParams,
): Promise<CoursewareAudioItem[]> {
  const res = await service.post(COURSEWARE_AUDIO_API, {
    topicId: String(params.topicId),
  });
  return normalizeCoursewareAudioResponse(res);
}
